export const addEventListener = (
	type: string,
	selector: string,
	callback: (e: Event) => void
) => {
	document.body.addEventListener(type, (e) => {
		const target = e.target as HTMLElement;

		if (target.closest(selector)) {
			callback(e);
		}
	});
};
